module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/207/assets/images/ce78e4d8a89276d538f87b8a09051586.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_move.svg
// module id = T7vb
// module chunks = 1